import {  Tooltip } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import { entrezDbSelectors } from "../../app/store/entrezDbSlice";

interface Props {
  children?: React.ReactNode;
  keyValue: string;
}

export default function CustomToolTip(props: Props) {
  const { dbParams } = useAppSelector((state) => state.entrezDb);

  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  var fieldFound = selectedDbWithItsState?.fieldlist.find(
    (f) => (f.fullname.toUpperCase() === props.keyValue || f.name.toUpperCase() === props.keyValue)
  );

  var tip = fieldFound === undefined ? props.keyValue : fieldFound.description;

console.log("Key is:" + props.keyValue + ". Tip is :"+ tip);

  return (
    <Tooltip title={tip}  placement="top-start">
      <div>{props.children}</div>
    </Tooltip>
  );
}
